import { defineMessages } from 'react-intl-next';
export var messages = defineMessages({
  createAndOpen: {
    id: 'linkCreate.createForm.button.createAndOpen',
    defaultMessage: 'Create + Open',
    description: 'Button to create the object and subsequently open a screen to edit'
  }
});